
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kurikulum-merdeka",
      function () {
        return require("private-next-pages/kurikulum-merdeka.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kurikulum-merdeka"])
      });
    }
  